import React, { useEffect, useState } from 'react';
import '../style/Engins.css';
import { TbTruckDelivery } from "react-icons/tb";
import { GrMap } from "react-icons/gr";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import { FaWrench } from "react-icons/fa";

const Engins = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector('.engins-section');
      if (section) {
        const scrollPosition = window.scrollY + 300;
        const sectionTop = section.offsetTop;
        if (scrollPosition >= sectionTop) {
          setIsVisible(true);
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const enginsData = [
    {
      id: 1,
      nom: 'Bulldozer',
      modele: 'Caterpillar D6',
      description: 'Terrassement lourd, déblaiement et nivellement des gros chantiers',
      image: '/img/bulldozer.jpg',
      // icone: <FaBulldozer />
    },
    {
      id: 2,
      nom: 'Pelle chargeuse',
      modele: 'CAT 950 GC',
      description: 'Chargement des matériaux, terrassement et manutention sur chantier',
      image: '/img/chargeuse.jpg',
      // icone: <GiExcavator />
    },
    {
      id: 3,
      nom: 'Pelle excavatrice',
      modele: 'Hitachi ZX210',
      description: 'Excavation, fondations et travaux de génie civil en profondeur',
      image: '/img/exc.jpg',
      // icone: <GiExcavator />
    },
    {
      id: 4,
      nom: 'Niveleuse',
      modele: 'Caterpillar 120H',
      description: 'Nivellement des pistes, routes et préparation des terrains',
      image: '/img/niveleuse.jpg',
      // icone: <FaRoad />
    },
    {
      id: 5,
      nom: 'Camions bennes 12 roues',
      modele: 'Mercedes 2628',
      description: 'Transport et évacuation des matériaux avec une capacité de 20m³',
      image: '/img/camion.jpg',
      // icone: <FaTruck />
    },
    {
      id: 6,
      nom: 'Porte charges',
      modele: 'MAN TGS 33.440',
      description: 'Transport de charges lourdes et de matériel de chantier',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      // icone: <FaBoxes />
    },
    {
      id: 7,
      nom: 'Compact routier',
      modele: 'MAN TGS 33.440',
      description: 'Transport de charges lourdes et de matériel de chantier',
      image: '/img/compact routier.jpg',
      // icone: <FaBoxes />
    }
  ];

  return (
    <section id="engins" className="engins-section">
      <div className="container">
        {/* En-tête */}
        <div className={`section-header ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          <span className="section-tag">Notre parc</span>
          <h2>Des engins puissants et bien entretenus</h2>
          <div className="separator"></div>
          <p>Des machines adaptées à tous vos chantiers avec ou sans opérateur</p>
        </div>

        {/* Grille des engins */}
        <div className="engins-grid">
          {enginsData.map((engin, index) => (
            <div 
              key={engin.id}
              className={`engin-card ${isVisible ? `fade-in-up delay-${index + 1}` : 'opacity-0'}`}
            >
              <div className="engin-image">
                <img src={engin.image} alt={engin.nom} />
                <div className="engin-overlay">
                  <div className="engin-icon">{engin.icone}</div>
                </div>
              </div>
              <div className="engin-content">
                <h3>{engin.nom}</h3>
                <p className="engin-modele">{engin.modele}</p>
                <p className="engin-description">{engin.description}</p>
                <div className="engin-features">
                  <span className="feature-tag"> <GrMap /> Location avec opérateur</span>
                  <span className="feature-tag"> <TbTruckDelivery /> Livraison sur site</span>
                </div>
                <a href="#contact" className="engin-btn">Demander un devis</a>
              </div>
            </div>
          ))}
        </div>

        {/* Informations complémentaires */}
        <div className={`engins-info ${isVisible ? 'fade-in-up delay-7' : 'opacity-0'}`}>
          <div className="engins-info-content">
            <div className="info-item">
              <span className="info-icon"><HiMiniWrenchScrewdriver /></span>
              <p>Location avec ou sans opérateur qualifié</p>
            </div>
            <div className="info-item">
              <span className="info-icon"><TbTruckDelivery /></span>
              <p>Livraison possible sur tout le Cameroun depuis notre base de Denver à Douala</p>
            </div>
            <div className="info-item">
              <span className="info-icon"><FaWrench /></span>
              <p>Matériels entretenus et vérifiés avant chaque location</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Engins;